export default __webpack_public_path__ + "d71f2b410a71f580c617c206e45a565a.jpeg";